import React from 'react'
import Button from '../../atoms/button/button'
import Menu from '../../atoms/menu/menu'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import './prizes-content.scss'

const PrizesContent = () => {
  const {
    premioPrincipal: { childImageSharp: premioPrincipal },
    premio1: { childImageSharp: premio1 },
    premio2: { childImageSharp: premio2 },
    premio3: { childImageSharp: premio3 },
    bannerFooter: { childImageSharp: bannerFooter },
    bannerFooterMobile: { childImageSharp: bannerFooterMobile },
  } = useStaticQuery(graphql`
    {
      premioPrincipal: file(name: { eq: "Premio-iphone" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      premio1: file(name: { eq: "Premio1" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      premio2: file(name: { eq: "Premio2" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      premio3: file(name: { eq: "Premio3" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      bannerFooter: file(name: { eq: "Banner-Felicitaciones" }) {
        childImageSharp {
          gatsbyImageData(width: 1400)
        }
      }
      bannerFooterMobile: file(name: { eq: "Banner-Felicitaciones-mobile" }) {
        childImageSharp {
          gatsbyImageData(width: 960)
        }
      }
    }
  `)
  const challengePrizes = [
    {
      image: premioPrincipal,
      title: 'Primer lugar',
      text: 'Serán 3 ganadoras de un iPhone 12 de 64 GB cada una',
      isPrimary: true,
    },
    {
      image: premio1,
      title: 'Reto 1',
      text: 'Set pastel power Edding (10 ganadoras)',
    },
    {
      image: premio2,
      title: 'Reto 2',
      text: 'Bono de Netflix y de Tennis (10 ganadoras)',
    },
    {
      image: premio3,
      title: 'Reto 3',
      text: 'Lettering E-Book Toy (Parte 1)',
    },
  ]
  return (
    <div>
      <Menu />
      <div className="f-prizes">
        <h1 className="f-prizes__title">
          UNA <b>GRAN AVENTURA </b>SIEMPRE VIENE
          <span> ACOMPAÑADA DE PREMIOS</span>
        </h1>
        <p className="f-prizes__description">Conoce todo lo que puedes ganar</p>
        <div className="f-principal-prize">
          <GatsbyImage
            objectFit="contain"
            image={getImage(premioPrincipal)}
            className="f-principal-prize__img"
          />
          <h1 className="f-principal-prize__title">Primer lugar</h1>
          <p className="f-principal-prize__description">
            Serán <b> 3 ganadoras </b> de un iPhone 12 de 64 GB cada una
          </p>
        </div>
        <hr className="f-separator" />

        <div className="f-prizes-container">
          {challengePrizes.map(prize => (
            <div
              className={`f-prize ${prize.isPrimary ? 'f-prize--primary' : ''}`}
            >
              <GatsbyImage
                objectFit="contain"
                className="f-prize__img"
                image={getImage(prize.image)}
              />
              <h2 className="f-prize__title">{prize.title}</h2>
              <p className="f-prize__description">{prize.text}</p>
            </div>
          ))}
        </div>
        <Button color="pink">Inscríbete ahora</Button>
      </div>
      {/* <GatsbyImage
        className="f-banner-prizes"
        objectFit="cover"
        image={withArtDirection(getImage(bannerFooter), [
          {
            media: '(max-width: 900px)',
            image: getImage(bannerFooterMobile),
          },
        ])}
      /> */}
    </div>
  )
}

export default PrizesContent
